export default {
      id: "gallery-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#gallery",
      toString: function () {
        return this.url;
      }
    }